// extracted by mini-css-extract-plugin
export default {"plan-head":"my-apis_plan-head__sOvmP","plan-body":"my-apis_plan-body__DMs2y"};